module.exports = __webpack_public_path__ + "static/media/bike-primary.27a718ee.svg";